import { useContext,useState} from "react";
import TableInfoPayRollIncident from "../../components/TableInfoPayRollIncident";
import TableEditPayRollIncident from "../../components/TableEditPayRollIncident";
import { closeModalPayrollIncident } from "../../../../context/PayRollIncidentContext/Actions";
import PayRollIncidentContext from '../../../../context/PayRollIncidentContext/PayRollIncidentContext';
import {
  Dialog,
  DialogTitle,
  DialogContent,     
} from '@material-ui/core';
import  { DialogProps } from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import "./ModalPayRollIncidents.css";


const ModalPayrollIncident = () => {
  const {state, dispatch} =   useContext(PayRollIncidentContext);  
  const [scroll ] = useState<DialogProps['scroll']>('paper');
  const [setNewInfo]=useState();
  const {Colaborador,email}=state?.payRollIncident  

  return (
    <>
    <Dialog open={state.modalPayRollIncendent} 
       aria-labelledby="form-dialog-title" 
       className="dialogPrestacion"    
       fullWidth={true}
       maxWidth={'xs'}     
       scroll={scroll}
     >     
     <DialogTitle id="alert-dialog-title" >
          <div className='containerInfoColaboradorIncident'> 
            <div className='nameColaboradorIncident'>{Colaborador}</div>
            <div className='emailColaboradorIncident'> {email}</div>
          </div>
          <IconButton aria-label="close" 
                onClick={(()=> {  //formik.resetForm();
                                 // resetStates();
                                 closeModalPayrollIncident({_id:'',editView:'',modalPayRollIncendent:false}  , dispatch)} )}
          sx={{position: 'absolute', right: 8, top: 8,color: (theme) => theme.palette.grey[500], }}
       >
      <CloseIcon />
     </IconButton> 
     </DialogTitle>    
     {state?.editView ==='view'?
     <DialogContent>
      <TableInfoPayRollIncident row ={state?.payRollIncident }/>
     </DialogContent>     
     :
     <DialogContent>
       <TableEditPayRollIncident 
         row ={state?.payRollIncident }
         setNewInfo={setNewInfo}
       />
     </DialogContent>
     }    
     <div className='containerBtnsPayRollIncident'> 
         <div className="containerCancelBtnPayRollIncident">
                <button className="btnCancelPrestacion" type="button" 
                    onClick={(() =>{
                         closeModalPayrollIncident({_id:'',editView:'',modalPayRollIncendent:false}  , dispatch)
                             }
                          )}>
                        CERRAR
                </button>             
          </div>
      </div>
    </Dialog>    
   
    </>  
  )
}

export default ModalPayrollIncident